import { sourceChipClass } from "@/lib/status-tone";
import { cn } from "@/lib/utils";

/** DESIGN §20.9: an item's `source`, or a link's origin written the same way. */
export function SourceChip({ source, count }: { source: string; count?: number }) {
  return (
    <span
      className={cn(
        "inline-flex h-5 items-center gap-1 rounded px-1.5 font-mono text-[10.5px] whitespace-nowrap",
        sourceChipClass(source),
      )}
    >
      {source}
      {count !== undefined && <span className="tabular-nums">{count}</span>}
    </span>
  );
}

/** A bucket's `mix`, leaving out the sources it took nothing from. */
export function MixLine({ mix }: { mix: Record<string, number> }) {
  const shown = Object.entries(mix).filter(([, n]) => n > 0);
  if (shown.length === 0) return null;
  return (
    <span className="flex flex-wrap gap-1.5">
      {shown.map(([source, n]) => (
        <SourceChip key={source} source={source} count={n} />
      ))}
    </span>
  );
}
